import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  currentUser: {},
  token: "",
  avatar: "",
  subscriptionStatus: false,
  freePlan: false,
  remainingDays: 0,
};

const authenticationSlice = createSlice({
  name: "authenticationValues",
  initialState,
  reducers: {
    login(state, action) {
      state.isLoggedIn = true;
      state.currentUser = action.payload.user;
      action.payload.token &&
        localStorage.setItem("token", action.payload.token);
      action.payload.avatar &&
        localStorage.setItem("avatar", action.payload.avatar);
      state.token = action.payload.token ? action.payload.token : state.token;
      state.avatar = action.payload.avatar;
      state.subscriptionStatus = action.payload.subscriptionStatus? action.payload.subscriptionStatus: state.subscriptionStatus;
      if (action.payload.avatar === null) {
        localStorage.setItem("avatar", "");
      }
    },
    freePlan(state, action) {
      state.freePlan = action.payload.free;
      state.remainingDays = action.payload.remainingDays;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.subscriptionStatus = false;
      state.freePlan = false;
      state.token = "";
      state.avatar = "";
      state.currentUser = {};
      const preserveLanguage = localStorage.getItem("i18nextLng");
      localStorage.removeItem("prevLocation");
      localStorage.clear();
      if (preserveLanguage) {
        localStorage.setItem("i18nextLng", preserveLanguage);
      }
    },
  },
});

export const { login, logout, freePlan } = authenticationSlice.actions;
export default authenticationSlice.reducer;
